import { addClickListener, PointerType } from './clickListener'

export const addDoubleClickListener = (
  elem: HTMLElement,
  callback: (e: MouseEvent, clickType: 'double' | 'single') => void,
  pointerTypeListen: PointerType
) => {
  let firstClickTime: number
  let isFirstClick = true
  let singleClickTimer: NodeJS.Timeout

  return addClickListener(elem, (e, pointerType) => {
    if (pointerType === pointerTypeListen || pointerTypeListen === 'both') {
      if (isFirstClick) {
        isFirstClick = false
        firstClickTime = Date.now()
        singleClickTimer = setTimeout(() => {
          isFirstClick = true
          callback(e, 'single')
        }, 300)
      } else if (Date.now() - firstClickTime < 300) {
        clearTimeout(singleClickTimer)
        isFirstClick = true
        callback(e, 'double')
      }
    }
  })
}
